import { MsalProvider } from "@azure/msal-react";
import { FC } from "react";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { RydeEventsWrapper, RydeTimers } from "@ryde/controls";
import { SessionStoreProvider, useRtl } from "@ryde/redux";
import { msalPublicClientApplication } from "@ryde/shared";

import "../../root.css";

import { App } from "./app";

export const AppRootSpa: FC = () => {
  const { isRtl } = useRtl();
  return (
    <MsalProvider instance={msalPublicClientApplication}>
      <SessionStoreProvider>
        <App />
        <ToastContainer
          rtl={isRtl}
          position={isRtl ? "top-left" : "top-right"}
        />
        <RydeEventsWrapper />
        <RydeTimers />
      </SessionStoreProvider>
    </MsalProvider>
  );
};
